// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    label: string;
    tip?: string;
    optional?: boolean;
    optionalLabel?: string;
    extendedStyles?: FieldLabelAndTipStyles;
    overridedStyles?: FieldLabelAndTipStyles;
}

type Props = OwnProps;

interface FieldLabelAndTipStyles {
    labelOptionalText?: TypographyPresentationProps;
    labelTipText?: TypographyPresentationProps;
}

const fieldLabelAndTipStyles: FieldLabelAndTipStyles = {
    labelTipText: {
        variant: "p",
        css: css`
            margin-top: ${pxToRem(5)};
            ${({ theme }) => `
                font-size: ${theme.design.typography.size.smallest};
                font-weight: ${theme.design.typography.weight.base};
            `}
        `,
    },
    labelOptionalText: {
        css: css`
            font-weight: ${x => x.theme.design.typography.weight.base};
            margin-left: ${pxToRem(8)};
        `,
    },
};

const FieldLabelAndTip = ({ label, tip, optional, optionalLabel, extendedStyles, overridedStyles }: Props) => {
    const styles = useExpandProps(fieldLabelAndTipStyles, extendedStyles, overridedStyles);

    return (
        <>
            <Typography>{label}</Typography>
            {optional && (
                <Typography {...styles.labelOptionalText}>({optionalLabel || translate("optional")})</Typography>
            )}
            {tip?.length && <Typography {...styles.labelTipText}>{tip}</Typography>}
        </>
    );
};

export default FieldLabelAndTip;
